import React, { useMemo } from 'react'

import { digObject } from '@domain-group/javascript-utils'

import formatDate from '@functions/formatDate'

import { Table, Text, StatusBadge } from '@domain-group/suit-theme'

import { SmsLogModel } from '@models/smsLog'

import Actions from '../Actions'

const messageStatusColor = (messageStatus: string) => {
  if (messageStatus === 'delivered') return 'green'
  if (messageStatus === 'sent') return 'orange'
  return 'red'
}

const buildColumns = () => [
  {
    title: 'Date',
    dataKey: 'dates',
    cellProps: {
      position: 'sticky',
      left: 0,
      width: '20%',
    },
    render: (datesObject: object) => {
      const createdAt = digObject(datesObject, 'created.date_time', '')
      const formattedDateformatDate = formatDate(createdAt, 'dd/MM/yyyy HH:mm', "ccc dd LLL yy 'at' hh:mma")

      return (
        <Text variant="ellipsis">
          {formattedDateformatDate}
        </Text>
      )
    },
  },
  {
    title: 'API Provider',
    dataKey: 'api_provider',
    cellProps: {
      width: 100,
    },
    render: (apiProvider: string) => apiProvider || 'Not Set',
  },
  {
    title: 'Owner',
    dataKey: 'owner_type',
    cellProps: {
      style: { whiteSpace: 'noWrap' },
    },
    render: (ownerType: string, smsLog: SmsLogModel) => `${ownerType} #${smsLog.owner_id}`,
  },
  {
    title: 'Entity',
    dataKey: 'entity_type',
    cellProps: {
      style: { whiteSpace: 'noWrap' },
    },
    render: (entityType: string, smsLog: SmsLogModel) => `${entityType} #${smsLog.entity_id}`,
  },
  {
    title: 'Status',
    dataKey: 'message_status',
    cellProps: {
      textAlign: 'center',
      width: 40,
    },
    render: (messageStatus: string) => (
      <Text textAlign="center">
        <StatusBadge
          ghost
          color={messageStatusColor(messageStatus)}
          text={messageStatus}
        />
      </Text>
    ),
  },
  {
    title: '',
    dataKey: 'download',
    cellProps: {
      textAlign: 'center',
      width: 40,
    },
    // @ts-expect-error TS7006
    render: (download, smsLog: SmsLogModel) => (
      <Actions smsLog={smsLog} />
    ),
  },
]

const SmsLogTable = (props: { smsLogs: SmsLogModel[] }) => {
  const { smsLogs } = props

  const memoColumns = useMemo(() => buildColumns(), [smsLogs.length])

  return (
    <Table
      boxProps={{ border: 'none', maxHeight: 800, overflowY: 'auto' }}
      // @ts-expect-error TS2322
      columns={memoColumns}
      // @ts-expect-error TS2322
      data={smsLogs}
      scroll={{ x: 900 }}
      stickyHeader
    />
  )
}

export default React.memo(SmsLogTable)
